<template>
  <div class="container m-y-5 text-center">
    <div class="PERM-MESSAGE" selenium="pro-permission-container">
      <div v-if="header" class="h6 m-b-1 text-bold c-gray80" selenium="pro-permission-header">
        {{ header }}
      </div>
      <template v-if="message" class="c-gray70" selenium="pro-permission-message">
        {{ message }}
      </template>
      <template v-else>
        Sorry, there was a permission exception on the page.
      </template>
    </div>

    <a v-if="cta && url" class="btn" @click="goTo(url)" selenium="call-us-button">
      {{ cta }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'permission-exception',
  props: {
    header: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
    cta: {
      type: String,
      default: '',
    },
    code: {
      type: String,
      default: '',
    },
  },
  mounted () {
    this.$events.$emit(this.$events.PRO_PERM_ERROR, {
      reason: this.code,
      type: 'page-load',
    });
  },
  methods: {
    goTo (url) {
      this.$events.$emit(this.$events.PRO_PERM_ERROR, {
        reason: this.code,
        type: 'cta-click',
      });
      // TODO: This shouldn't be a timeout, $events should return a promises
      setTimeout(() => {
        window.location.href = url;
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools.scss";

.PERM-MESSAGE {
  @include margin(4 auto);
  max-width: 632px;
}
</style>
